import React, { useEffect, useState, useContext } from "react"
import ImageElement from "../../../../ProjectNonSpecificComponents/Elements/ImageElement"
import getUrl from "components/ProjectNonSpecificComponents/Functions/getUrl"
import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { TGET_Logo } from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import { observer } from "mobx-react"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { useHistory } from "react-router"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import HdLogo from "icons/HdLogo"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { lostOrFinishedUserSession } from "components/ProjectSpecificComponents/API/Functions/lostOrFinishedUserSession"
import { UserContext } from "components/ProjectSpecificComponents/Contexts/UserContext"
import { Dot, Dots } from "components/ProjectNonSpecificComponents/Elements/Loader/LoadingText"

interface Props {}
/**
 * Logo from Settings
 */
export const Logo = observer(({}: Props) => {
	const store = useStore()
	const [image, setImage] = useState<string>("")
	const [show, setShow] = useState<boolean>(false)
	const { setUser } = useContext(UserContext)
	const history = useHistory()
	const formStore = useFormStore()

	const className = !store.isInAdminSection
		? concatWithSpaces(
				!formStore.settingsData.personalize.bigLogo ? "small-logo" : "h-28 w-auto m-1",
				"cursor-pointer"
		  )
		: "small-logo cursor-pointer"

	const getAndSetLogo = async () => {
		setShow(false)
		setImage("")
		const { ok, data, statusCode } = await AppRequests("Setting").get<TGET_Logo>("get-logo")
		if (store.tempIconUrl) {
			setImage(store.tempIconUrl)
		} else if (ok && data) {
			const imgPath = typeof data == "object" ? data.url : ""
			const fullUrl = `${getUrl.base}${imgPath}`
			setImage(fullUrl)
		} else if (statusCode == 401) {
			setUser(undefined)
			lostOrFinishedUserSession(store)
		}
		setShow(true)
	}

	const goToHome = () => {
		history.push(ROUTES.USER)
		setTimeout(() => {
			history.push(ROUTES.USER)
		}, 10)
	}
	useEffect(() => {
		getAndSetLogo()
	}, [store.logoUploaded, store.tempIconUrl])

	return (
		<>
			{!show ? (
				<Dots>
					<Dot />
					<Dot />
					<Dot />
				</Dots>
			) : (
				<div onClick={goToHome}>
					{image && <ImageElement image={image} className={className} />}
					{show && !image && <HdLogo />}
				</div>
			)}
		</>
	)
})

export default Logo
